import { Alert, Divider, Flex, Row, Spin } from "antd";
import { ClaimKanbanLane } from "./components/ClaimKanbanLane";
import { ClaimKanbanFilters } from "./components/ClaimKanbanFilters";
import { useQuery } from "@tanstack/react-query";
import { fetchClaims } from "../../../lib/api/resources/claims";
import { getEnumValue } from "@/lib/formatter/dossiers";
import type { LaneGroup } from "./ClaimKanbanOverview";
import { groupColors } from "./ClaimKanbanOverview";

interface Lane {
  key: string;
  label: string;
  group: LaneGroup;
}

const lanes: Lane[] = [
  { key: "nieuwe", label: "Wacht op documenten", group: "intake" },
  {
    key: "wacht_op_documenten",
    label: "In behandeling",
    group: "calculatie",
  },
  { key: "afgerond", label: "Afgerond", group: "afgerond" },
];

export default function ClaimKanbanClaimsOverview() {
  const claimsQuery = useQuery({
    queryKey: ["claims", "claims-kanban"],
    queryFn: fetchClaims,
  });

  const allClaims = claimsQuery.data?.member ?? [];
  const claimsWithOtherParty = allClaims.filter(
    (claim) =>
      getEnumValue(claim.dossier?.otherPartyInvolved) === "known_other_party",
  );

  const claimsByLane: Record<string, typeof allClaims> = {
    nieuwe: claimsWithOtherParty,
    wacht_op_documenten: [],
    afgerond: [],
  };

  return (
    <div style={{ padding: 16 }}>
      <Flex vertical gap={16}>
        <ClaimKanbanFilters />
        <Divider style={{ margin: 0 }} />

        {claimsQuery.isLoading ? (
          <Spin />
        ) : claimsQuery.isError ? (
          <Alert
            type="error"
            message="Fout bij het laden van claims"
            description="Probeer het later opnieuw."
          />
        ) : (
          <Row className="overflow-x-scroll flex-nowrap" gutter={[16, 16]}>
            {lanes.map((lane) => (
              <ClaimKanbanLane
                key={lane.key}
                title={lane.label}
                claims={claimsByLane[lane.key] ?? []}
                groupColor={groupColors[lane.group]}
              />
            ))}
          </Row>
        )}
      </Flex>
    </div>
  );
}
